export default {
  name: 'cash',
  path: 'cash',
  component: () => import(/* webpackChunkName: "cash" */ './index.vue')
}
